import { connect } from 'react-redux'
import { compose } from 'redux'
import toJS from '../../../hoc/toJS'
import { FLYER_ELEMENT_DEFAULT } from '../../../constants/state'
import EditElement from '../../PageEditItem/present/EditElement'
import { addFlyerElement } from '../../../actions'

const mapDispatchToProps = dispatch => ({
    addFlyerItem: (item, elementType) => {
        dispatch(addFlyerElement(elementType, item))
    }
})

const AddTitleContainer = ({addFlyerItem, itemType, closePagePath}) => (
    <EditElement 
        closePagePath={closePagePath}
        itemType={itemType}
        itemData={FLYER_ELEMENT_DEFAULT}
        onUpdateItem={addFlyerItem}
    />
)

export default compose(
    connect(null, mapDispatchToProps),
    toJS()
)(AddTitleContainer)